import { withAuthRecovery } from '@/lib/authRecovery'
import { getSupabase } from '@/lib/supabase'

export type LessonHistorySortKey = 'date' | 'visitors' | 'direction' | 'group' | 'address'

export interface PedagogyTeacherLessonHistoryRow {
  lessonDate: string
  lessonTime: string | null
  cityName: string
  studioAddress: string | null
  directionName: string | null
  groupName: string | null
  visitorsCount: number
}

export interface PedagogyTeacherLessonHistoryPage {
  rows: PedagogyTeacherLessonHistoryRow[]
  totalCount: number
}

export async function listPedagogyTeacherLessonHistory(input: {
  periodId: number
  weekNumber?: number | null
  partnerNumber: number
  cityId: number
  teacherId?: string | null
  limit?: number
  offset?: number
  sortBy?: LessonHistorySortKey
  sortDirection?: 'asc' | 'desc'
}): Promise<PedagogyTeacherLessonHistoryPage> {
  const teacherId = input.teacherId?.trim() || null
  const { data, error } = await withAuthRecovery(() => getSupabase().rpc('list_pedagogy_teacher_lesson_history' as never, {
    p_period_id: input.periodId,
    p_week_number: input.weekNumber ?? null,
    p_partner_number: input.partnerNumber,
    p_city_id: input.cityId,
    p_teacher_id: teacherId,
    p_limit: input.limit ?? 20,
    p_offset: input.offset ?? 0,
    p_sort_by: input.sortBy ?? 'date',
    p_sort_direction: input.sortDirection ?? 'desc',
  } as never))

  if (error) throw new Error(error.message)
  const rawRows = (data ?? []) as Array<Record<string, unknown>>
  return {
    rows: rawRows.map(row => ({
      lessonDate: String(row.lesson_date),
      lessonTime: row.lesson_time == null ? null : String(row.lesson_time),
      cityName: String(row.city_name ?? ''),
      studioAddress: row.studio_address == null ? null : String(row.studio_address),
      directionName: row.direction_name == null ? null : String(row.direction_name),
      groupName: row.group_name == null ? null : String(row.group_name),
      visitorsCount: Number(row.visitors_count ?? 0),
    })),
    totalCount: Number(rawRows[0]?.total_count ?? 0),
  }
}
